let popupOpen = function (popup) {
    removeErrorInfo();
    popup.querySelector('form').reset();
    popup.classList.remove('hide');
}

let openPdfOffertPopupEvent = function (e) {
    e.preventDefault();
    let popup = document.getElementById(e.target.dataset.pdfgenerator);
    if (popup === null) {
        console.warn('#' + e.target.dataset.pdfgenerator + ' doesn\'t exist');
        return false;
    }
    popupOpen(popup);
    return false;

};

let closeContentEvent = function (e) {
    let content = document.getElementById(e.target.dataset.contentpopup);
    if (content === null) {
        console.warn('#' + e.target.dataset.contentpopup + ' doesn\'t exist');
        return;
    }
    content.classList.add('hide');
    content.querySelector('form').reset();
};

let formToSend = function (form, e, additionaParams = '?source=prod_ids') {

    removeErrorInfo();

    let parts = document.querySelectorAll('form[name="big_send_pdf_to_email"] input[type="checkbox"]');
    parts.forEach(function (input) {
        if (input.checked) {

            let toSend = document.createElement('input');
            toSend.type = 'hidden';
            toSend.name = input.name;
            toSend.value = input.value;

            form.appendChild(toSend);

        }
    });

    switch (e.target.dataset.bigcom_act) {
        case 'sendemail':

            let email = document.querySelector('form[name="big_send_pdf_to_email"] input[name="email"]').value;

            if (!/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(String(email).toLowerCase())) {
                return false;
            }

            let emailField = document.createElement("input");
            emailField.type = emailField.name = 'email';
            emailField.value = document.querySelector('form[name="big_send_pdf_to_email"] input[name="email"]').value;
            form.appendChild(emailField);
            break;
        default:
    }

    form.setAttribute('action', e.target.dataset.bigcom_url + additionaParams);

    document.body.appendChild(form);
    form.submit();

    document.body.removeChild(form);

}

let executeLinkEvent = function (e) {

    if (document.querySelector('body').getAttribute('id') === 'cart') {

        let form = document.createElement('form');
        form.method = 'POST';
        form.style.display = 'none';

        formToSend(form, e, '');

    } else {

        let form = dataToPdfGenerator();

        removeErrorInfo();

        if (form.querySelector('[name=items]').value.length < 5) {
            document.getElementsByName('big_send_pdf_to_email')[0].insertAdjacentHTML('afterend', '<p id="big_send_error_info" style="margin-top:15px;text-align:center;width:100%;">' + document.getElementsByName('big_send_pdf_to_email')[0].dataset.errornoitems + '</p>');
            return;
        }

        formToSend(form, e, '?source=prod_ids');

    }

};

let removeErrorInfo = function () {
    if (null !== document.getElementById('big_send_error_info')) {
        document.getElementById('big_send_error_info').remove();
    }
}

let offerCheckboxExent = function (e) {
    if (!e.target.checked) {
        e.target.checked = true;
    }
}

window.addEventListener('load', function (e) {

    let btnsOpen = document.querySelectorAll('[data-pdfgenerator]');
    btnsOpen.forEach(function (btn) {
        btn.addEventListener('click', openPdfOffertPopupEvent);
    });

    let btns = document.querySelectorAll('[data-contentpopup]');

    btns.forEach(function (btn) {
        btn.addEventListener('click', closeContentEvent);
    });


    let btnsLinks = document.querySelectorAll('[data-bigcom_url]');
    btnsLinks.forEach(function (btn) {
        btn.addEventListener('click', executeLinkEvent);
    });

    document.getElementById('pdf_offer').addEventListener('change', offerCheckboxExent);

});

// addToBasketItemsFromConfigurator
// saveCartToPDF